export * from './kinship.pipe';
